// App.jsx (ou App.js)
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate } from 'react-router-dom';
import React, { useEffect, useRef, useState } from 'react';
import { Download } from 'lucide-react';
import Reglement from './pages/Reglement';
import BilanAnnuelPresences2025_2026 from './pages/BilanAnnuelPresences2025_2026';

// Import des pages
import FicheSante from './pages/FicheSante';
import ParentBulletins from './pages/ParentBulletins';
import Login from './pages/Login';
import Register from './pages/Register';
import AdminDashboard from './pages/AdminDashboard';
import ListeEtudiants from './pages/ListeEtudiants';

import Etudiantpage from './pages/Etudiantpage';
import NotificationAbsences from './pages/NotificationAbsences';
import ListeCours from './pages/ListeCours';
import AjouterPaiement from './pages/AjouterPaiement';
import ListePaiements from './pages/ListePaiements';
import Calendrier from './pages/Calendrier';
import ProfilEtudiant from './pages/ProfilEtudiant';
import AjouterPresence from './pages/AjouterPresence';
import ListePresences from './pages/ListePresences';
import AjouterProfesseur from './pages/AjouterProfesseur';
import ListeProfesseurs from './pages/ListeProfesseurs';
import ProfesseurDashboard from './pages/ProfesseurDashboard';
import ListePresenceProf from './pages/ListePresenceProf';
import EtudiantsProfesseur from './pages/EtudiantsProfesseur';
import EtudiantPhotoUpload from './pages/EtudiantPhotoUpload';
import Profile from './pages/Profile';
import EtudiantPresences from './pages/EtudiantPresences';
import EvenementsProf from './pages/EvenementsProf';
import EvenementsEtudiant from './pages/EvenementsEtudiant';
import DocumentsEtudiant from './pages/DocumentsEtudiant';
import DocumentsProfesseur from './pages/DocumentsProfesseur';
import ExercicesCoursProf from './pages/ExercicesCoursProf';
import ListeCoursProf from './pages/ListeCoursProf';
import EtudiantPaiements from './pages/EtudiantPaiements';
import TeleverserExerciceEtudiant from './pages/TéléverserExerciceEtudiant';
import MesExercicesEtudiant from './pages/MesExercicesEtudiant';
import EtudiantLiveCours from './pages/EtudiantLiveCours';
import LiveCoursEtudiant from './pages/LiveCoursEtudiant';
import ProfLiveCours from './pages/ProfLiveCours';
import ProfileProfesseur from './pages/ProfileProfesseur';
import QREtudiant from './pages/qretudiant';
import Dashboardmanager from './pages/Dashboardmanager';
import ProfAjouterBulletin from './pages/ProfAjouterBulletin';
import AdminBulletins from './pages/AdminBulletins';
import EtudiantBulletins from './pages/EtudiantBulletins';
import MessageProf from './pages/MessageProf';
import MessageEtudiant from './pages/MessageEtudiant';
import ProfileUpdatePage from './pages/ProfileUpdatePage';
import PaiementsExp from './pages/PaiementsExp';
import KastlerHomepage from './pages/KastlerHomepage';
import AdminAjouterSeance from './pages/AdminAjouterSeance';
import ActualitesPage from './pages/ActualitesPage';
import VieScolairePage from './pages/VieScolairePage';
import SeancesEtudiant from './pages/SeancesEtudiant';
import SeancesProfesseur from './pages/SeancesProfesseur';
import ContactPage from './pages/ContactPage';
import CyclesPage from './pages/CyclesPage';
import AdminMessages from './pages/AdminMessages';
import Suiviassiduitesimple from './pages/Suiviassiduitesimple';
import Propos from './pages/Propos';
import AdminVieScolaire from './pages/AdminVieScolaire';
import EcolePrimairePage from './pages/EcolePrimairePage';
import CrechePrescolairePage from './pages/CrechePrescolairePage';
import CollegePage from './pages/CollegePage';
import LyceePage from './pages/LyceePage';
import AdminActualites from './pages/AdminActualites';
import PresenceManuelleAdmin from './pages/PresenceManuelleAdmin';
import PaiementManagerPage from './pages/PaiementManagerPage';
        import ParentEmploiDuTemps from './pages/ParentEmploiDuTemps';

import AdminMessagesmanager from './pages/AdminMessagesmanager';
import AdminVieScolairemanager from './pages/AdminVieScolairemanager';
import AdminActualitesmanager from './pages/AdminActualitesmanager';
import EtudiantProfil from './pages/EtudiantProfil';
import ProfesseurProfil from './pages/ProfesseurProfil';
import InscripteurPage from './pages/InscripteurPage';
import InscripteurDashboard from './pages/PaymentManagementSystem';
import AbsencesParCours from './pages/AbsencesParCours';
import AutorisationEtudiants from './pages/AutorisationEtudiants';
import ManagementPage from './pages/ManagementPage';
import EtudiantsAutorisesProfesseur from './pages/EtudiantsAutorisesProfesseur';
import ReclamationsProfesseur
 from './pages/ReclamationsProfesseur';

         
import Rapportsmanager from './pages/Rapportmanager';


import  GestionParents from './pages/GestionParents';
 import  BadgeGeneratorModern
 from './pages/BadgeGeneratorModern';
        import ParentDashboard from './pages/ParentDashboard';
import ParentAbsences from './pages/ParentAbsences';
import AdminProfManagement from './pages/AdminProfManagement';
import EtudiantPublic from './pages/EtudiantPublic';
import PageProfesseurRapports from './pages/PageProfesseurRapports';

import ParentRapports from './pages/ParentRapports';
import MesRapports from './pages/MesRapports';

import ListePresencesmanager from './pages/ListePresencesmanager';
import HistoriqueEtudiant from './pages/HistoriqueEtudiant';
import GestionPaiementManagers from './pages/GestionPaiementManagers';
import DashboardPaiementManager from './pages/DashboardPaiementManager';
import AdminQRGenerator
 from './pages/AdminQRGenerator';
 import PageAdminRapports from './pages/PageAdminRapports';
 import ManagerEtudiants from './pages/ManagerEtudiants';
 import  MangerHistorique
 from './pages/MangerHistorique';
import BadgeGeneratorProfesseurs from './pages/BadgeGeneratorProfesseurs';
import ScanPointageProf from './pages/ScanPointageProf';

 

 import AdminPointagesView from './pages/AdminPointagesView';
import ProfQRScanner from './pages/ProfQRScanner';
// Dans vos routes
function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();

  // Prompt PWA stocké ici (n'entraîne pas de re-render)
  const deferredPromptRef = useRef(null);

  // Peut-on afficher le bouton d'install ?
  const [canInstall, setCanInstall] = useState(false);

  // L'app est-elle installée ? (persisté + détection standalone)
  const [isInstalled, setIsInstalled] = useState(() => {
    const standalone =
      window.matchMedia?.('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    const persisted = localStorage.getItem('pwaInstalled') === '1';
    return standalone || persisted;
  });

  // Effet pour rediriger vers login lors du premier lancement après installation
  useEffect(() => {
    const isStandalone = 
      window.matchMedia?.('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    
    const hasRedirectedOnce = localStorage.getItem('hasRedirectedToLogin') === '1';
    
    // Debug info
    console.log('🔍 Debug PWA:', {
      pathname: location.pathname,
      isStandalone,
      isInstalled,
      canInstall,
      hasServiceWorker: 'serviceWorker' in navigator,
      hasManifest: !!document.querySelector('link[rel="manifest"]'),
      protocol: location.protocol,
      hostname: location.hostname
    });
    
    // Si l'app est en mode standalone ET qu'on n'a jamais redirigé
    if (isStandalone && !hasRedirectedOnce && location.pathname === '/') {
      localStorage.setItem('hasRedirectedToLogin', '1');
      navigate('/login', { replace: true });
    }
  }, [location.pathname, navigate, isInstalled, canInstall]);

  // Écoute du prompt et de l'installation
  useEffect(() => {
    const onBeforeInstallPrompt = (e) => {
      e.preventDefault();
      deferredPromptRef.current = e;
      // Afficher le bouton uniquement si on est sur /login
      setCanInstall(location.pathname === '/login');
    };

    const onAppInstalled = () => {
      deferredPromptRef.current = null;
      setCanInstall(false);
      setIsInstalled(true);
      localStorage.setItem('pwaInstalled', '1');
      // Marquer pour redirection au prochain lancement
      localStorage.removeItem('hasRedirectedToLogin');
      // Rediriger vers /login une fois installée
      navigate('/login', { replace: true });
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    window.addEventListener('appinstalled', onAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
      window.removeEventListener('appinstalled', onAppInstalled);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  // Quand la route change, afficher/masquer le bouton selon /login
  useEffect(() => {
    if (location.pathname !== '/login') {
      setCanInstall(false);
    } else if (!isInstalled) {
      // Afficher le bouton sur /login même sans prompt (pour les instructions)
      setCanInstall(true);
    }
  }, [location.pathname, isInstalled]);

  // Fonction pour détecter si l'installation est possible
  const isInstallable = () => {
    // Vérifier les critères PWA basiques
    const hasServiceWorker = 'serviceWorker' in navigator;
    const hasManifest = document.querySelector('link[rel="manifest"]');
    const isHTTPS = location.protocol === 'https:' || location.hostname === 'localhost';
    
    return hasServiceWorker && hasManifest && isHTTPS;
  };

  // Clic sur "Installer"
  const handleInstallClick = async () => {
    const deferredPrompt = deferredPromptRef.current;
    
    if (deferredPrompt) {
      // Si on a un prompt, l'utiliser directement
      setCanInstall(false);
      deferredPrompt.prompt();

      try {
        const choice = await deferredPrompt.userChoice;
        deferredPromptRef.current = null;

        if (choice?.outcome === 'accepted') {
          console.log('✅ PWA installée par l\'utilisateur');
          setIsInstalled(true);
          localStorage.setItem('pwaInstalled', '1');
          localStorage.removeItem('hasRedirectedToLogin');
          navigate('/login', { replace: true });
        } else {
          console.log('❌ Installation refusée par l\'utilisateur');
          // Réafficher le bouton après un délai
          setTimeout(() => {
            if (location.pathname === '/login' && !isInstalled) {
              setCanInstall(true);
            }
          }, 2000);
        }
      } catch (error) {
        console.error('Erreur lors de l\'installation:', error);
        deferredPromptRef.current = null;
      }
      return;
    }

    // Si pas de prompt, donner des instructions
    const isChrome = /Chrome/.test(navigator.userAgent);
    const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    const isFirefox = /Firefox/.test(navigator.userAgent);
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    let instructions = 'Pour installer cette application:\n\n';
    
    if (isMobile) {
      if (isSafari) {
        instructions += '📱 Sur Safari iOS:\n';
        instructions += '• Appuyez sur le bouton Partager 📤\n';
        instructions += '• Sélectionnez "Sur l\'écran d\'accueil"\n';
        instructions += '• Confirmez l\'ajout';
      } else {
        instructions += '📱 Sur mobile:\n';
        instructions += '• Appuyez sur les 3 points du menu\n';
        instructions += '• Sélectionnez "Ajouter à l\'écran d\'accueil"\n';
        instructions += '• Ou "Installer l\'application"';
      }
    } else {
      if (isChrome) {
        instructions += '💻 Sur Chrome/Edge:\n';
        instructions += '• Cliquez sur les 3 points (⋮) en haut à droite\n';
        instructions += '• Sélectionnez "Installer Alfred Kastler"\n';
        instructions += '• Ou cherchez l\'icône 📥 dans la barre d\'adresse';
      } else if (isFirefox) {
        instructions += '💻 Sur Firefox:\n';
        instructions += '• Cliquez sur les 3 lignes (≡) en haut à droite\n';
        instructions += '• Sélectionnez "Installer cette application"';
      } else {
        instructions += '💻 Sur votre navigateur:\n';
        instructions += '• Utilisez le menu principal\n';
        instructions += '• Cherchez "Installer l\'application"\n';
        instructions += '• Ou "Ajouter à l\'écran d\'accueil"';
      }
    }

    alert(instructions);
  };

  // Masquer le bouton si déjà en mode standalone
  const isStandalone =
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  const shouldShowInstallButton =
    !isStandalone && 
    !isInstalled && 
    canInstall && 
    location.pathname === '/login' &&
    isInstallable(); // Vérifier que les conditions PWA sont remplies

  return (
    <>
      {/* Bouton d'installation: UNIQUEMENT sur /login */}
      {shouldShowInstallButton && (
        <button
          onClick={handleInstallClick}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            padding: '12px 18px',
            background: 'linear-gradient(to right, #e60039, #8a2be2)',
            color: 'white',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            zIndex: 999,
            transition: 'all 0.3s ease',
            fontSize: '14px'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.2)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
          }}
          title="Installer l'application sur cet appareil"
        >
          <Download size={18} />
          Installer l'app
        </button>
      )}

      <Routes>
        {/* Route par défaut */}
        <Route path="/" element={<KastlerHomepage />} />
        
        {/* Routes publiques (toujours accessibles) */}
        <Route path="/propos" element={<Propos />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/Cycles" element={<CyclesPage />} />
        <Route path="/ecole-primaire" element={<EcolePrimairePage />} />
        <Route path="/CrechePrescolaire" element={<CrechePrescolairePage />} />
        <Route path="/college" element={<CollegePage />} />
        <Route path="/lycee" element={<LyceePage />} />
        <Route path="/actualites" element={<ActualitesPage />} />
        <Route path="/Vie-Scolaire" element={<VieScolairePage />} />
<Route path="/admin/gestionnaire-paiement" element={<GestionPaiementManagers />} />
        <Route path="/admin/pointages" element={<AdminPointagesView />} />
        <Route path="/badges-professeurs" element={<BadgeGeneratorProfesseurs />} />
        <Route path="/pointage-professeurs" element={<ScanPointageProf />} />
        {/* Auth public */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/prof/qr-scanner" element={<ProfQRScanner />} />
<Route path="/etudiants/:id/reglement" element={<Reglement />} />
        <Route path="/badge-generator" element={<BadgeGeneratorModern />} />
        <Route path="/professeur/mes-rapports" element={<MesRapports />} />
        <Route path="/professeur/rapports" element={<PageProfesseurRapports />} />
        {/* Routes Admin */}

<Route path="/public/management" element={<ManagementPage />} />
        <Route path="/manager/rapports" element={<Rapportsmanager />} />


<Route path="/parent/bulletins" element={<ParentBulletins />} />
<Route path="/parent/emploi-du-temps" element={<ParentEmploiDuTemps />} />
        <Route path="/admin/rapports" element={<PageAdminRapports />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/liste-etudiants" element={<ListeEtudiants />} />
        <Route path="/manager/etudiants" element={<ManagerEtudiants />} />
<Route path="/etudiants/:id/fiche-sante" element={<FicheSante />} />
<Route path="/bilan-annuel-2025-2026" element={<BilanAnnuelPresences2025_2026 />} />

        <Route path="/notification-absences" element={<NotificationAbsences />} />
        <Route path="/ajouter-paiement" element={<AjouterPaiement />} />
        <Route path="/liste-paiements" element={<ListePaiements />} />
        <Route path="/liste-classe" element={<ListeCours />} />
        <Route path="/calendrier" element={<Calendrier />} />
        <Route path="/etudiants/:id" element={<ProfilEtudiant />} />
        <Route path="/ajouter-professeur" element={<AjouterProfesseur />} />
        <Route path="/liste-professeurs" element={<ListeProfesseurs />} />
        <Route path="/ajouter-presence" element={<AjouterPresence />} />
        <Route path="/liste-presences" element={<ListePresences />} />
        <Route path="/update-profil" element={<ProfileUpdatePage />} />
        <Route path="/paiements-exp" element={<PaiementsExp />} />
        <Route path="/qr-etudiant" element={<QREtudiant />} />
        <Route path="/admin/seances" element={<AdminAjouterSeance />} />
        <Route path="/etudiant/seances" element={<SeancesEtudiant />} />
        <Route path="/professeur/seances" element={<SeancesProfesseur />} />

<Route path="/parent/dashboard" element={<ParentDashboard />} />
        <Route path="/admin/Bulletin" element={<AdminBulletins />} />
        <Route path="/manager/messages" element={<AdminMessagesmanager />} />
        <Route path="/admin/gestion-parents" element={<GestionParents />} />
        <Route path="/manager/liste-presences" element={<ListePresencesmanager />} />
        <Route path="/manager/presence-manuelle" element={<PresenceManuelleAdmin />} />
        <Route path="/etudiant/Bulletin" element={<EtudiantBulletins />} />
        <Route path="/professeur/AjouterBulletin" element={<ProfAjouterBulletin />} />
        <Route path="/manager/VieScolaire" element={<AdminVieScolairemanager />} />
        <Route path="/manager" element={<Dashboardmanager />} />
        <Route path="/admin/Manager" element={<PaiementManagerPage />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
        <Route path="/admin/VieScolaire" element={<AdminVieScolaire />} />
        <Route path="/admin/actualites" element={<AdminActualites />} />
        <Route path="/manager/actualites" element={<AdminActualitesmanager />} />
        <Route path="/admin/inscripteur" element={<InscripteurPage />} />

<Route path="/professeur/absences" element={<AbsencesParCours />} />
        {/* Routes Professeur */}
        <Route path="/professeur" element={<ProfesseurDashboard />} />
        <Route path="/professeur/profile" element={<ProfileProfesseur />} />
        <Route path="/presences" element={<ListePresenceProf />} />
        <Route path="/professeur/etudiants" element={<EtudiantsProfesseur />} />
        <Route path="/evenements-prof" element={<EvenementsProf />} />
        <Route path="/professeur/exercices/:nomCours" element={<ExercicesCoursProf />} />
        <Route path="/professeur/exercices" element={<ListeCoursProf />} />
        <Route path="/professeur/live" element={<ProfLiveCours />} />
        <Route path="/prof/documents" element={<DocumentsProfesseur />} />
        <Route path="/professeur/messages" element={<MessageProf />} />
<Route path="/admin/autorisations" element={<AutorisationEtudiants />} />

<Route path="/admin/suivi-assiduite-simple" element={<Suiviassiduitesimple />} />
<Route path="/admin/professeursmanagement" element={<AdminProfManagement />} />

<Route path="/professeur/reclamations" element={<ReclamationsProfesseur />} />

<Route path="/admin/qr-generator" element={<AdminQRGenerator />} />

 <Route path="/parent/absences" element={< ParentAbsences />} />  
 <Route path="/parent/rapports" element={< ParentRapports />} />  
<Route path="/admin/historique-etudiant" element={<HistoriqueEtudiant />} />  

<Route path="/manager/historique-etudiant" element={<MangerHistorique />} />  
<Route path="/professeur/etudiants-autorises" element={<EtudiantsAutorisesProfesseur />} />
        {/* Routes Étudiant */}
        <Route path="/etudiant/messages" element={<MessageEtudiant />} />
        <Route path="/professeur/profil" element={<ProfesseurProfil />} />
        <Route path="/etudiant/profil" element={<EtudiantProfil />} />
        <Route path="/etudiant" element={<EtudiantPhotoUpload />} />
        <Route path="/etudiant/profile" element={<Profile />} />
        <Route path="/etudiant/presences" element={<EtudiantPresences />} />
        <Route path="/etudiant/paiements" element={<EtudiantPaiements />} />
        <Route path="/evenements-etudiant" element={<EvenementsEtudiant />} />
        <Route path="/etudiant/documents" element={<DocumentsEtudiant />} />
        <Route path="/etudiant/mes-exercices" element={<MesExercicesEtudiant />} />
        <Route path="/etudiant/exercices/upload" element={<TeleverserExerciceEtudiant />} />
        <Route path="/etudiant/live" element={<LiveCoursEtudiant />} />
        <Route path="/etudiant/live/:cours" element={<EtudiantLiveCours />} />
<Route path="/etudiant/:id" element={<EtudiantPublic />} />

        <Route path="/dashboard/manager" element={<DashboardPaiementManager />} />
        <Route path="/etudiants/pageprofil" element={<Etudiantpage />} />

        <Route path="/admin/inscripteurs" element={<InscripteurDashboard />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}